import cogoToast from "cogo-toast";
import httpRequest from "../../ajax";

import { 
  CREATE_FEED_POST,
  GET_FEEDS_RESULTS,
  CREATE_COMMENT_POST,
  DELETE_FEEDS_CATEGORY,
  ERROR
} from "../actionTypes";

export const createFeedAction = (dispatch, data) => {
  return httpRequest("post", "/feeds/create", data)
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      if (responseData) {
        const action = { type: CREATE_FEED_POST, payload: responseData };
        dispatch(action);
        return {
          success: true,
          payload: responseData
        };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create post';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};

export const createCommentPostAction = (dispatch, data) => {
  return httpRequest("post", "/feeds/comment", data)
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      if (responseData) {
        const action = { type: CREATE_COMMENT_POST, payload: responseData };
        dispatch(action);
        return {
          success: true,
          payload: responseData
        };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to create comment';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};

export const getFeedsAction = (dispatch, page) => {
  return httpRequest("get", `/feeds`)
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      if (responseData) {
        const action = { type: GET_FEEDS_RESULTS, payload: responseData };
        dispatch(action);
        return {
          success: true,
          payload: responseData
        };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch feeds';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};

export const deleteFeedsAction = (dispatch, data) => {
  return httpRequest("delete", `/feeds/${data.item_id}`)
    .then((response) => {
      // Handle both possible response structures
      const responseData = response.data?.data || response.data;
      if (responseData) {
        const action = { type: DELETE_FEEDS_CATEGORY, payload: responseData };
        dispatch(action);
        return {
          success: true,
          payload: responseData
        };
      }
      throw new Error('Invalid response format');
    })
    .catch((error) => {
      const errorMessage = error.response?.data?.message || error.message || 'Failed to delete feed';
      dispatch({
        type: ERROR,
        payload: errorMessage
      });
      throw new Error(errorMessage);
    });
};


 

 

 
 